import { createHook } from 'react-sweet-state';
import { store } from '../store';
import type { State } from '../types';

export const isRollingUp = (state: State) => state.isRollingUp;

export const useWorklogRollingUpData = createHook(store, {
	selector: isRollingUp,
});
